(function () {
  var widgetDone = false
  var widgetTries = 0

  var initReviewsWidget = function () {
    if (widgetDone) return
    var el = document.querySelector('#ReviewsWidget')
    if (!el) return
    if (typeof window.ReviewsWidget !== 'function') {
      if (++widgetTries < 40) setTimeout(initReviewsWidget, 500)
      return
    }
    if (el.dataset.reviewsWidgetInit) return
    widgetDone = true
    el.dataset.reviewsWidgetInit = 'true'
    try {
      new window.ReviewsWidget('#ReviewsWidget', {
        store: 'atlasrecords-co-uk',
        widget: 'social-proof',
        options: {
          perspective: 30,
          card_amount: 5
        }
      })
    } catch (e) {
      widgetDone = false
      el.removeAttribute('data-reviews-widget-init')
    }
  }

  var snippetDone = false
  var snippetTries = 0

  var initRatingSnippet = function () {
    if (snippetDone) return
    if (!document.querySelector('.ruk_rating_snippet')) return
    if (typeof window.ratingSnippet !== 'function') {
      if (++snippetTries < 40) setTimeout(initRatingSnippet, 500)
      return
    }
    snippetDone = true
    try {
      window.ratingSnippet('ruk_rating_snippet', {
        store: 'atlasrecords-co-uk',
        color: '#f47e27',
        textClr: '#333333',
        linebreak: false,
        text: 'Reviews',
        lang: 'en',
        mode: 'default',
        showEmptyStars: false,
        enableSyndication: false
      })
      var modal = document.getElementById('reviews_fade')
      if (modal) modal.classList.add('rio-withoutBranding')
    } catch (e) {
      snippetDone = false
    }
  }

  var initAll = function () {
    initReviewsWidget()
    initRatingSnippet()
  }

  document.addEventListener('StartAsyncLoading', initAll)

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll)
  } else {
    initAll()
  }
})()
